import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'

import './tailwind.css'
import App from './App'

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://338b0062f65345b388114d73d2d1a192@o684990.ingest.sentry.io/5772005',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.25,
  })
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Could not find root element')
}

createRoot(rootElement).render(<App />)
